import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const NotificationContext = createContext(null);

let notifIdCounter = 0;

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const timersRef = useRef({});

  const addNotification = useCallback((message, type = 'info') => {
    const id = ++notifIdCounter;
    const notification = {
      id,
      message,
      type,
      timestamp: new Date(),
    };
    setNotifications(prev => [notification, ...prev]);

    // Auto-dismiss po 10 sekundach dla typow sukces/info/warning
    if (type === 'success' || type === 'info' || type === 'warning') {
      timersRef.current[id] = setTimeout(() => {
        setNotifications(prev => prev.filter(n => n.id !== id));
        delete timersRef.current[id];
      }, 10000);
    }

    return id;
  }, []);

  const updateNotification = useCallback((id, updates) => {
    setNotifications(prev =>
      prev.map(n => {
        if (n.id !== id) return n;
        const updated = { ...n, ...updates };
        // Jesli zmieniono typ na sukces/info/warning, ustaw auto-dismiss
        if (
          (updates.type === 'success' || updates.type === 'info' || updates.type === 'warning') &&
          !timersRef.current[id]
        ) {
          timersRef.current[id] = setTimeout(() => {
            setNotifications(p => p.filter(nn => nn.id !== id));
            delete timersRef.current[id];
          }, 10000);
        }
        return updated;
      })
    );
  }, []);

  const removeNotification = useCallback((id) => {
    if (timersRef.current[id]) {
      clearTimeout(timersRef.current[id]);
      delete timersRef.current[id];
    }
    setNotifications(prev => prev.filter(n => n.id !== id));
  }, []);

  return (
    <NotificationContext.Provider value={{ notifications, addNotification, updateNotification, removeNotification }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications musi byc uzywany wewnatrz NotificationProvider');
  }
  return context;
}
